<!-- <section id="faq" class="faq "> -->

<div class="container-fluid containersize" *ngIf="faqArray">
    <div class="section-title" data-aos="fade-up">
        <h2 *ngIf="loading" class=" primary ">
            <span class="loader pb-2">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
        </h2>
        <h2  class="primary" *ngIf="!loading">{{'journal_home.frequently_asked_questions' | translate}}</h2>
        <p *ngIf="loading" class="rvh-sub-heading">
            <span class="loader  rvh-sub-heading">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
        </p>
        <p  class="rvh-sub-heading" *ngIf="!loading">Find answers to frequently asked questions.</p>
    </div>

    <div *ngIf="loading">
        <div class="row faq-item d-flex align-items-stretch text-color rowfaq"
            *ngFor="let item of items; let i = index;" style="padding-left: 26.5rem;margin-left: auto;
                margin-right: auto;
                width: 100%;">
            <div class="col-lg-5">
                <i class="ri-question-line loader"> &nbsp; &nbsp; &nbsp;</i>
                <p class="loader">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
            </div>
            <div #showref class="col-lg-7">
                <p class="ellipsis loader">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                <p class="ellipsis loader">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                <button class="loader border-0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
            </div>
        </div>

    </div>
    <div *ngIf="!loading">
        <div class="row faq-item d-flex align-items-stretch text-color rowfaq"
            *ngFor="let data of faqArray | slice:0:limit ; let i = index;" style="padding-left: 26.5rem;margin-left: auto;
                margin-right: auto;
                width: 100%;">
            <div class="col-lg-5">
                <i class="ri-question-line"></i>
                <p [innerHTML]="data.faqQuestion"></p>
            </div>
            <div #showref class="col-lg-7">
                <p class="ellipsis" [innerHTML]="data.faqAnswer"></p>
                <button *ngIf="hidebutton[i]" style="float: right;
                border: thin;background: #e9eceff7;font-size: smaller;
            " (click)="showmore(i)">{{showbuttonstatus[i]?'less':'more'}}</button>
            </div>
        </div>

    </div>
    <div class="d-flex justify-content-center">
        <a class="explore-button loader " [routerLink]="'/journal/'+journalid+'/editorial-board'" *ngIf="loading">
            <!-- <span class="icon">
                <fa-icon class="long-arrow" [icon]="['fas', 'right-long']" size="2x"></fa-icon>
            </span> -->
           &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </a>
        <a class="explore-button" [routerLink]="'/journal/'+journalid+'/faq'" *ngIf="!loading">
            <span class="icon">
                <fa-icon class="long-arrow" [icon]="['fas', 'right-long']" size="2x"></fa-icon>
            </span>
            {{'journal_home.view_all' | translate}}
        </a>
    </div>
    <!-- <p class="fw-bold md-subhead fx-bold text-color-blue text-align-end rvh-view-more mt-4" data-aos="fade-right">
        <a [routerLink]="'/journal/'+journalid+'/faq'">
            {{'journal_home.view_all' | translate}}
            <fa-icon class="iconcls" aria-hidden="true" [icon]="['fas', 'circle-arrow-right']"></fa-icon>
        </a>
    </p> -->
</div>
<!-- </section> -->